/**
 * DOM rendering helpers for site plan lot polygon paths.
 *
 * Applies the active CSS class to all SVG lot path elements.
 * Generic overlay DOM helpers (positioning, clip-path) live in overlayDom.js.
 *
 * @module searchResultsMap/components/lotPolygons
 */

/**
 * CSS attribute selector for the SVG group element that contains all lot polygon paths.
 * Matches the `data-layer-type` attribute set by `buildLayerGroups` in overlayDom.js.
 */
const LOT_POLYGONS_SELECTOR = `g[data-layer-type='LotPolygons']`;

/**
 * Applies the active CSS class to all lot polygon paths in the SVG.
 *
 */
function renderLotStatusClasses(svgRoot, activeClass) {
  const allLotPaths = svgRoot.querySelectorAll(`${LOT_POLYGONS_SELECTOR} path[id]`);
  allLotPaths.forEach((path) => {
    path.classList.add(activeClass);
  });
}

export default renderLotStatusClasses;